module.exports = __webpack_public_path__ + "img/contact-banner.2fc8b795.png";